import * as React from 'react';
import {useTranslation} from 'react-i18next';
import {mergeStyleSets, TextCompat as Text} from 'components/FluentUICompat';

interface UserRolesDisplayProps {
	roleNames: string[];
}

export const UserRolesDisplay: React.FC<UserRolesDisplayProps> = ({
	roleNames,
}) => {
	const {t} = useTranslation('components/usersettings', {
		keyPrefix: 'UserSettings',
	});

	if (roleNames.length === 1) {
		return (
			<Text block variant='medium' className={styles.line}>
				{t('Role')}: {roleNames[0]}
			</Text>
		);
	}

	return (
		<>
			<Text block variant='medium' className={styles.line}>
				{t('Roles')}:
			</Text>
			<ul className={styles.list}>
				{roleNames.map(name => (
					<li key={name}>{name}</li>
				))}
			</ul>
		</>
	);
};

const styles = mergeStyleSets({
	line: {
		paddingLeft: '10px',
	},
	list: {
		margin: '2px 0 0',
		paddingLeft: '20px',
		fontSize: '14px',
		selectors: {
			'li::marker': {fontSize: '0.7em'},
		},
	},
});
